'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _components = require('components');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { manualTrack } from 'helpers/AnalyticService';
var SearchMobile = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SearchMobile, _Component);

  function SearchMobile() {
    (0, _classCallCheck3.default)(this, SearchMobile);
    return (0, _possibleConstructorReturn3.default)(this, (SearchMobile.__proto__ || (0, _getPrototypeOf2.default)(SearchMobile)).apply(this, arguments));
  }

  (0, _createClass3.default)(SearchMobile, [{
    key: 'toCategory',
    value: function toCategory(label) {
      _reactGa2.default.event({
        category: 'Home Category Icon',
        action: 'Clicked',
        label: '' + label
      });
      this.props.manualTrack({ label: label, button: 'Icon Category' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./CategoriesMobile.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.categoriesMobile },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/workshop', onClick: function onClick() {
              return _this2.toCategory('Workshop');
            } },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 4, sm: 4, xs: 4, className: styles.catItem },
            _react2.default.createElement(_components.Picture, {
              className: styles.catIcon,
              src: _Images2.default.cats.hoiThao,
              srcWebp: _Images2.default.cats.hoiThaoWebp
            }),
            'Workshop'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/life-coach', onClick: function onClick() {
              return _this2.toCategory('Life Coach');
            } },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 4, sm: 4, xs: 4, className: styles.catItem },
            _react2.default.createElement(_components.Picture, {
              className: styles.catIcon,
              src: _Images2.default.cats.khoaHoc,
              srcWebp: _Images2.default.cats.khoaHocWebp
            }),
            'Life Coach'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: '/salon-mi-va-mong',
            onClick: function onClick() {
              return _this2.toCategory('Salon Mi và Móng');
            }
          },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 4, sm: 4, xs: 4, className: styles.catItem },
            _react2.default.createElement(_components.Picture, {
              className: styles.catIcon,
              src: _Images2.default.cats.salonMiMong,
              srcWebp: _Images2.default.cats.salonMiMongWebp
            }),
            'Salon Mi v\xE0 M\xF3ng'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: '/spa-cham-da',
            onClick: function onClick() {
              return _this2.toCategory('Spa Chăm Da');
            }
          },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 4, sm: 4, xs: 4, className: styles.catItem },
            _react2.default.createElement(_components.Picture, {
              className: styles.catIcon,
              src: _Images2.default.cats.spaChamDa,
              srcWebp: _Images2.default.cats.spaChamDaWebp
            }),
            'Spa Ch\u0103m Da'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: '/massage-va-goi-dau',
            onClick: function onClick() {
              return _this2.toCategory('Massage Gội Đầu');
            }
          },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 4, sm: 4, xs: 4, className: styles.catItem },
            _react2.default.createElement(_components.Picture, {
              className: styles.catIcon,
              src: _Images2.default.cats.massageGoiDau,
              srcWebp: _Images2.default.cats.massageGoiDauWebp
            }),
            'Massage G\u1ED9i \u0110\u1EA7u'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: '/tham-my-va-nha-khoa',
            onClick: function onClick() {
              return _this2.toCategory('Thẩm Mỹ Nha Khoa');
            }
          },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 4, sm: 4, xs: 4, className: styles.catItem },
            _react2.default.createElement(_components.Picture, {
              className: styles.catIcon,
              src: _Images2.default.cats.thamMyNhaKhoa,
              srcWebp: _Images2.default.cats.thamMyNhaKhoaWebp
            }),
            'Th\u1EA9m M\u1EF9 Nha Khoa'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: '/salon-toc-va-make-up',
            onClick: function onClick() {
              return _this2.toCategory('Salon Tóc Make-up');
            }
          },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 4, sm: 4, xs: 4, className: styles.catItem },
            _react2.default.createElement(_components.Picture, {
              className: styles.catIcon,
              src: _Images2.default.cats.salonTocMakeUp,
              srcWebp: _Images2.default.cats.salonTocMakeUpWebp
            }),
            'Salon T\xF3c Make-up'
          )
        )
      );
    }
  }]);
  return SearchMobile;
}(_react.Component), _class.propTypes = {
  manualTrack: _react.PropTypes.func
}, _temp);
exports.default = SearchMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/CategoriesMobile.js
// module id = 1599
// module chunks = 0